import React from 'react'
import ItemDisplays from '../../__item/_displays/catalog__item_displays'
import Icon from 'blocks.simple/icon/icon'
import { api } from 'core/api/ConnectionManager'
import helpersDigitalSignages from 'core/helpers/_digitalSignages'
import translate from 'core/translate'
import styles from './catalog__template__draftDevices.jcss'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { ItemData } from '../../../../core/models/Template'

type Status = 'offline' | 'error' | 'online'

const noBroadcastCover = helpersDigitalSignages.getNoBroadcastIconSrc()

export default {
    getMethod: 'getDraftDisplays',
    getByFiltersMethod: 'getDisplaysAndGroupsByFilters',
    getByFiltersParams: {
        limit: 35,
    },
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noDevices'),
    emptyIcon: 'not_allow',
    settingsPrefixes: 'draftDevices',
    tile: ItemDisplays,
    viewOptions: () => [
        {
            id: 'tile',
            name: translate('tile'),
            icon: 'tile',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
        {
            id: 'list',
            name: translate('list'),
            icon: 'list',
            iconColor: getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable,
            iconActiveColor: getThemeStyleValue('ui', 'icon', 'active') || defaultThemeStyles.active,
        },
    ],
    sortOptions: () => [
        { id: '-createdAt', name: translate('sortCreatedAt') },
        { id: 'name', name: translate('byNameAsc') },
        { id: '-name', name: translate('byNameDesc') },
        { id: 'status', name: translate('sortStatusOnline') },
        { id: '-status', name: translate('sortStatusOffline') },
    ],
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.cover) {
            item.cover = []
        }
        item.cover = [...item.cover, ...[noBroadcastCover, noBroadcastCover, noBroadcastCover, noBroadcastCover]]
        item.cover = item.cover.slice(0, 4)

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }
        if (!item.type) {
            item.type = 'digitalSignage'
        }

        return item
    },
    getBackendModel: (item: ItemData) => {
        return api.send('getDisplay', { id: item.id }, { hideLoader: true })
    },
    isEqual: helpersDigitalSignages.isEqual,
    onCreateListeners: [
        (cb: any, clearList: string[]) => api.addObserver('groupCreated', cb, clearList),
        (cb: any, clearList: string[]) => api.addObserver('displayCreated', cb, clearList),
    ],
    onUpdateListeners: [
        (cb: any, clearList: string[]) => api.addObserver('groupUpdated', cb, clearList),
        (cb: any, clearList: string[]) => api.addObserver('displayUpdated', cb, clearList),
    ],
    onDeleteListeners: [
        (callback: any, clearListeners: string[]) =>
            api.addObserver(
                'groupDeleted',
                ({ id }: { id: number }) => callback({ id, type: 'group' }),
                clearListeners
            ),
        (callback: any, clearListeners: string[]) =>
            api.addObserver(
                'displayDeleted',
                ({ id }: { id: number }) => callback({ id, type: 'digitalSignage' }),
                clearListeners
            ),
    ],
    isFolder: () => {},
    fields: () => [
        { id: 'name', name: translate('name') },
        { id: 'status', name: translate('status') },
    ],
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        status: ({ status, type }: { status: string; type: string }) => {
            const color: { [index: string]: Status } = { offline: 'offline', error: 'error', online: 'online' }

            return (
                <div className={styles.status}>
                    <Icon type={type === 'group' ? 'files' : 'display'} size={20} color={color[status]} />
                </div>
            )
        },
    },
    disableUpdateUserSettings: true,
    useNewFilter: true,
    allowAdvancedSearch: true,
    isDraft: true
}
